export const siteSettings = {
  name: "Orbital Markets",
  link: "https://orbitalmarkets.net",
  email: "support@orbitalmarkets.net",
  appLink: "https://app.orbitalmarkets.net",
};
